var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.featureImage)?_c('div',{staticClass:"bg-white rounded-md overflow-hidden shadow hidden md:block mt-4"},[_c('img',{staticClass:"w-full",attrs:{"src":_vm.featureImage,"id":"topimg"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }